import React, { Component } from 'react';
import { generateKey } from '../../utils/utils.js'
import ProgressiveImage from './ImageLoad';


class Assetblock extends Component {
  state = {
    loaded: 'not-loaded'
  }

  loadImage = () =>{
   
    this.setState(
      {loaded: 'loaded'}
    )
  }

  render() {
      let content = this.props.content;
      let index = this.props.index;
      let dim, full, heightConstrain;
        if (content.data.target.fields.file.url.includes('mov') || content.data.target.fields.file.url.includes('mp4')) {
            return (
              <div key={generateKey(index)} className="width-full-width">
                <video  width="320" height="240" controls playsInline >
                  <source src={content.data.target.fields.file.url} type="video/mp4" />
                </video>
              </div>
            )
          } else {
            content.data.target.fields.file.details.image.width > content.data.target.fields.file.details.image.height ? dim = "horizon" : dim = "vert";
            content.data.target.fields.file.details.image.width > 2000 ? full = "full-width" : full = "half-width";
            content.data.target.fields.file.details.image.width  > 900 && dim === "vert" ? heightConstrain = "half-height" : heightConstrain = "";
            return (
              <div key={generateKey(index)} className={`dimension-${dim} width-${full} ${heightConstrain}`}>
                <ProgressiveImage
                      key={index} 
                      alt={content.data.target.fields.file.url}
                      dim={dim}
                      height={800}
                      preview={`${content.data.target.fields.file.url}?w=800`}
                      image={`${content.data.target.fields.file.url}?w=800`}
                  />
              </div>
            )
        }
  }

}

export default Assetblock;



// WEBPACK FOOTER //
// ./src/Posts/elements/Assetblock.js